import { Grid } from "@mui/material";
import ServiceExperience from "./service-experience";
import EmployeeExperience from "./employee-experience";

interface IProps {
  cityId: string;
  locations: string[];
  dateRange: {
    startDate: Date | null;
    endDate: Date | null;
  };
  rates: string[];
  clientId: string;
  searchBy: string;
  selectedService: string;
}

const ExperienceStatistics = (props: IProps) => {
  const {
    cityId,
    dateRange,
    rates,
    locations,
    clientId,
    searchBy,
    selectedService,
  } = props;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={6}>
        <ServiceExperience
          cityId={cityId}
          locations={locations}
          dateRange={dateRange}
          rates={rates}
          clientId={clientId}
          searchBy={searchBy}
          selectedService={selectedService}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <EmployeeExperience
          cityId={cityId}
          locations={locations}
          dateRange={dateRange}
          rates={rates}
          clientId={clientId}
          searchBy={searchBy}
          selectedService={selectedService}
        />
      </Grid>
    </Grid>
  );
};

export default ExperienceStatistics;
